module.exports = __webpack_public_path__ + "img/23_right.38cb6261.png";